import React, { useState, useEffect } from 'react';

import ApprovalForm from './ApprovalForm';
import { ActivityIndicator, StyleSheet } from 'react-native';
import { CommonProperties, Color } from '../../styles';

export default function ApproalViewer(props) {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (props?.approvalKey !== undefined && props?.approvalList?.length > 0) {
      setLoading(false);
    }
  }, [props]);

  return loading ? (
    <ActivityIndicator style={styles.loadingIndicator} />
  ) : (
    <ApprovalForm {...props} />
  );
}

const styles = StyleSheet.create({
  loadingIndicator: {
    ...CommonProperties.mr4,
    color: Color.primary,
  },
});
